module.exports = __webpack_public_path__ + "static/14-bbabc2ca882d4389e5c085c9b123af8f.png";